import muiltiBenefitsRoutes from "./multi/routes";
import { IRoute, RenderRoutes } from "@src/routes";
import { Redirect } from "react-router-dom";

const routes: IRoute[] = [
  {
    menu: { label: "Gerenciamento de benefícios" },
    path: "/benefits",
    key: "BENEFITS",
    component: (props: any) => (
      <div className="flex w-full h-full">
        <RenderRoutes {...props} />
      </div>
    ),
    routes: [
      {
        path: "/benefits/",
        key: "BENEFITS_ROOT",
        exact: true,
        component: () => <Redirect to="/benefits/multi" />,
      },
      ...muiltiBenefitsRoutes,
    ],
  },
];

export default routes;
